"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var dividerSize = Object.freeze({
  xs: 'var(--border-width-xs)',
  s: 'var(--border-width-s)',
  m: 'var(--border-width-m)',
  l: 'var(--border-width-l)',
  xl: 'var(--border-width-xl)'
});
var _default = exports["default"] = dividerSize;